import { ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import React from 'react';

import { AlertChips } from './AlertChips';
import { AlertDescription } from './AlertDescription';
import { getSeverityColor, parseAlertName, PortHealthAlertData } from './utils';

export interface AlertListItemProps {
  alert: PortHealthAlertData;
  icon: React.ReactNode;
}

export const AlertListItem: React.FC<AlertListItemProps> = ({ alert, icon }) => {
  const { location, type } = parseAlertName(alert.name);

  return (
    <ListItem
      style={{
        paddingTop: 4,
        paddingBottom: 4,
        borderLeft: `4px solid ${getSeverityColor(alert.value)}`,
        backgroundColor: 'rgba(0,0,0,0.05)',
        marginBottom: 4,
      }}
    >
      <ListItemIcon style={{ minWidth: 36 }}>
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={<AlertChips location={location} type={type} />}
        secondary={
          <Typography component="span" style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1rem', marginTop: 8, display: 'block' }}>
            <AlertDescription alert={alert} />
          </Typography>
        }
      />
    </ListItem>
  );
};
